const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const { getCurrentDateInDefaultFormat } = require("./utilities");
const api = "orders";

const orderStatus = [
	"Pago exitoso",
	"Pedido exitoso",
	"Pago en verificación",
	"Pago rechazado",
	"Pendiente de pago",
	"Alistando pedido",
	"En proceso de entrega",
	"Entregado",
	"Anulado",
	"Error generando enlace",
	"Pedido masivo generado",
	"Pedido masivo entregado",
];

const createOrder = (
	{
		orderProducts,
		client,
		deliveryMethod,
		paymentMethod,
		generateEletronicInvoice,
		paymentBank = undefined,
		paymentBankId = undefined,
		isMultiple = false,
		depotToUse = null,
		multipleUniqueId = null,
		invoiceDate = null,
		additionalDetails = null,
		extraAdditionalDetails = null,
		generatedAdvance = null,
		selectedHeadquarter = "",
		userType = "",
	},
	associatedUser = "",
	institutional = null,
	isCustom = false
) => {
	return new Promise((resolve, reject) => {
		postRequest(
			`${api}${isMultiple ? "/multiple" : ""}${
				institutional ? "/institutional" : ""
			}${isCustom ? "/custom" : ""}${
				associatedUser ? `?associatedUser=${associatedUser}` : ""
			}`,
			{
				orderProducts,
				client,
				deliveryMethod,
				paymentMethod,
				institutional,
				generateEletronicInvoice,
				isMultiple,
				paymentBank,
				paymentBankId,
				depotToUse,
				multipleUniqueId,
				invoiceDate,
				additionalDetails,
				extraAdditionalDetails,
				generatedAdvance,
				selectedHeadquarter,
				userType,
			},
			resolve,
			reject,
			true
		);
	});
};

const uploadPaymentFromOrder = (id, data) => {
	return new Promise((resolve, reject) => {
		putRequest(`${api}/payment/${id}`, data, resolve, reject);
	});
};

const uploadOrderDocument = (id, data) => {
	return new Promise((resolve, reject) => {
		putRequest(`${api}/orderDocument/${id}`, data, resolve, reject);
	});
};

const putGenerateIntegrationInvoice = (id) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/integration/${id}`,
			{
				invoiceDate: getCurrentDateInDefaultFormat(),
			},
			resolve,
			reject,
			true
		);
	});
};

const deleteGenerateIntegrationInvoice = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/integration/${id}`, resolve, reject, true);
	});
};

const deleteOrder = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getOrderDetails = (id, full = "false") => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}?full=${full}`, resolve, reject, true);
	});
};

const getOrderInvoice = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/invoice/${id}`, resolve, reject, true);
	});
};

const getSystemOrderDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/system/${id}`, resolve, reject, true);
	});
};

const getOrders = (
	status,
	page,
	total,
	queryString = "",
	allowedInstitutions = null
) => {
	return new Promise((resolve, reject) => {
		getRequest(
			`${api}?status=${
				status === "Todos" ? "" : status
			}&page=${page}&total=${total}${queryString ? queryString : ""}${
				allowedInstitutions ? "&allowedInstitutions=" + allowedInstitutions : ""
			}`,
			resolve,
			reject,
			true
		);
	});
};

const getOrderByCode = (code) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/code/${code}`, resolve, reject, true);
	});
};

const updateOrder = ({
	_id,
	status,
	deliveryPricing,
	orderProducts,
	client,
	institution,
}) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${_id}`,
			{ status, deliveryPricing, orderProducts, client, institution },
			resolve,
			reject,
			true
		);
	});
};

const synchronizeOrders = () => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/synchronize`, resolve, reject, true);
	});
};

const updateOrderStatus = (id, info = {}, code = false) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${id}/changeStatus${code ? "?code=true" : ""}`,
			info,
			resolve,
			reject,
			true
		);
	});
};

const cancelOrder = (id, message) => {
	return new Promise((resolve, reject) => {
		putRequest(`${api}/${id}/cancel`, { message }, resolve, reject, true);
	});
};

const getUpdateMessage = (status, code, allDigital = false) => {
	let messsage = "";
	if (status === "Pago exitoso" || status === "Pedido exitoso") {
		messsage = `¿Quieres pasar el pedido "${code}" a proceso de alistamiento?`;
	} else if (status === "Pago en verificación") {
		messsage = `¿Confirmas que el pago ha sido recibido por Wisdom?`;
	} else if (status === "Alistando pedido" && !allDigital) {
		messsage = `¿Quieres pasar el pedido "${code}" a proceso de entrega?`;
	} else if (
		status === "En proceso de entrega" ||
		status === "Pedido masivo generado" ||
		(status === "Alistando pedido" && allDigital)
	) {
		messsage = `¿Quieres marcar el pedido "${code}" como entregado?`;
	} else if (status === "Pendiente de pago") {
		messsage = `¿Quieres aprobar el pago del pedido "${code}"?`;
	}
	return messsage;
};

module.exports = {
	createOrder,
	getOrderByCode,
	getOrderInvoice,
	deleteOrder,
	getOrderDetails,
	getSystemOrderDetails,
	synchronizeOrders,
	getOrders,
	updateOrder,
	updateOrderStatus,
	getUpdateMessage,
	uploadPaymentFromOrder,
	cancelOrder,
	orderStatus,
	putGenerateIntegrationInvoice,
	deleteGenerateIntegrationInvoice,
	uploadOrderDocument,
};
